export default __webpack_public_path__ + "static/media/question-svgrepo-com.bf7b4205.svg";